import api from './apiConfig';

// apiConfig monta gia' `${API_URL}${API_BASE_PATH}`, cioe' /v1, come baseURL:
// i percorsi qui sono relativi a quello, come fanno permissionService e userAdminService.
const roleAdminService = {
    listPermissionCatalog: () => api.get('/permissions').then((r) => r.data),
    listRoles: () => api.get('/roles').then((r) => r.data),
    getRole: (id) => api.get(`/roles/${encodeURIComponent(id)}`).then((r) => r.data),
    createRole: (body) => api.post('/roles', body).then((r) => r.data),
    duplicateRole: (id, body) =>
        api.post(`/roles/${encodeURIComponent(id)}/duplicate`, body).then((r) => r.data),
    updateRole: (id, body) =>
        api.put(`/roles/${encodeURIComponent(id)}`, body).then((r) => r.data),
    deleteRole: (id) => api.delete(`/roles/${encodeURIComponent(id)}`),
    replacePermissions: (id, permissions) =>
        api.put(`/roles/${encodeURIComponent(id)}/permissions`, { permissions })
            .then((r) => r.data),
    listRoleUsers: (id) =>
        api.get(`/roles/${encodeURIComponent(id)}/users`).then((r) => r.data),
};

export default roleAdminService;
